import React from 'react';
import { PostMessageProps, PostMessage } from '@common/components/post-message';
import { clsx } from 'clsx';

export type ConversationPostProps = PostMessageProps & { id: string };

type ConversationProps = {
  posts: ConversationPostProps[];
  className?: string;
  emptyMessage?: string;
};

export function Conversation({
  posts = [],
  emptyMessage = 'No notes added yet',
  className,
}: ConversationProps) {
  return (
    <>
      <div className={clsx('wk-conversation', className)}>
        {posts.length ? (
          posts.map((post) => (
            <div
              key={post.id}
              className="wk-conversation__post"
              data-testid="wk-conversation__post"
            >
              <PostMessage {...post} />
            </div>
          ))
        ) : (
          <div className="text-center">
            <PostMessage.Empty>{emptyMessage}</PostMessage.Empty>
          </div>
        )}
      </div>
      <style jsx>{`
        .wk-conversation__post + .wk-conversation__post {
          margin-top: 24px;
        }
      `}</style>
    </>
  );
}
